'use es6';

export const DEFAULT_DEBOUNCE_TIME = 250;
export const MENU_TREE_INDENTATION = 24;
export const MENU_DIVIDER_MARGIN_OFFSET = 1.25;
export const REQUEST_STATUS = Object.freeze({
  UNINITIALIZED: 'UNINITIALIZED',
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
});